var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgBlurHero03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1064,
    height: 834,
    viewBox: "0 0 1064 834",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_336_9623)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 470.5,
    cy: 450.5,
    rx: 300.5,
    ry: 213.5,
    fill: "url(#paint0_linear_336_9623)",
    fillOpacity: 0.53
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_336_9623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351 323.5C351 227.679 477.032 150 632.5 150C787.968 150 914 227.679 914 323.5C914 419.321 787.968 497 632.5 497C477.032 497 351 419.321 351 323.5Z",
    fill: "url(#paint1_linear_336_9623)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_336_9623",
    x: 0,
    y: 67,
    width: 941,
    height: 767,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 85,
    result: "effect1_foregroundBlur_336_9623"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_336_9623",
    x: 201,
    y: 0.0000267029,
    width: 863,
    height: 647,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_336_9623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_336_9623",
    x1: 408.205,
    y1: 337.902,
    x2: 585.801,
    y2: 697.261,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11D48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_336_9623",
    x1: 748.99,
    y1: 424.473,
    x2: 593.491,
    y2: 46.3467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11A5D4",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#11D43C",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBlurHero03);
export default __webpack_public_path__ + "static/media/bg_blur-hero-03.0d2d2455e8a8006a50b0a35b5efca0e8.svg";
export { ForwardRef as ReactComponent };